const model = {
    typeDetails: null,
    loading: false,
    error: null,
};

export default model;